import type { Time_Entries } from "@/src/gql/graphql";
import { TIME_ENTRY_CONFIG } from "@/features/time-entries/components/TimeEntryConfig";
import { TIME_ENTRY_DETAIL_CONFIG } from "@/features/time-entries/components/TimeEntryDetailConfig";
import { getFieldValue } from "@/components/shared/UniversalCRMTable/components/SimpleTable/tableCellFieldValue";
import { defineEntity } from "../types";

// ============================================================================
// TIME ENTRIES ENTITY DEFINITION
// ============================================================================
// Column change: edit features/time-entries/components/TimeEntryConfig.ts fields.
// New saved view: edit features/time-entries/config/saved-views.ts.
// ============================================================================

export const timeEntriesEntity = defineEntity<Time_Entries>({
  tableConfig: TIME_ENTRY_CONFIG,

  detailConfig: TIME_ENTRY_DETAIL_CONFIG,

  synthesizeField(item, fieldId) {
    return getFieldValue(item, fieldId);
  },
});
